/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutiveAssistantInvitation
 */
export interface ExecutiveAssistantInvitation {
    /**
     * 
     * @type {number}
     * @memberof ExecutiveAssistantInvitation
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ExecutiveAssistantInvitation
     */
    assistantEmail: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExecutiveAssistantInvitation
     */
    accepted: boolean;
    /**
     * Name of the executive who sent the invitation
     * @type {string}
     * @memberof ExecutiveAssistantInvitation
     */
    executiveName: string;
    /**
     * True if the current user sent this invitation, false if they received it
     * @type {boolean}
     * @memberof ExecutiveAssistantInvitation
     */
    isSentByCurrentUser: boolean;
    /**
     * Token for new-user signup link (only visible to inviter)
     * @type {string}
     * @memberof ExecutiveAssistantInvitation
     */
    inviteToken?: string | null;
    /**
     * Expiry time for new-user invites (only visible to inviter)
     * @type {Date}
     * @memberof ExecutiveAssistantInvitation
     */
    expiresAt?: Date | null;
}

/**
 * Check if a given object implements the ExecutiveAssistantInvitation interface.
 */
export function instanceOfExecutiveAssistantInvitation(value: object): value is ExecutiveAssistantInvitation {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assistantEmail' in value) || value['assistantEmail'] === undefined) return false;
    if (!('accepted' in value) || value['accepted'] === undefined) return false;
    if (!('executiveName' in value) || value['executiveName'] === undefined) return false;
    if (!('isSentByCurrentUser' in value) || value['isSentByCurrentUser'] === undefined) return false;
    return true;
}

export function ExecutiveAssistantInvitationFromJSON(json: any): ExecutiveAssistantInvitation {
    return ExecutiveAssistantInvitationFromJSONTyped(json, false);
}

export function ExecutiveAssistantInvitationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutiveAssistantInvitation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assistantEmail': json['assistant_email'],
        'accepted': json['accepted'],
        'executiveName': json['executive_name'],
        'isSentByCurrentUser': json['is_sent_by_current_user'],
        'inviteToken': json['invite_token'] == null ? undefined : json['invite_token'],
        'expiresAt': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
    };
}

export function ExecutiveAssistantInvitationToJSON(json: any): ExecutiveAssistantInvitation {
    return ExecutiveAssistantInvitationToJSONTyped(json, false);
}

export function ExecutiveAssistantInvitationToJSONTyped(value?: ExecutiveAssistantInvitation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assistant_email': value['assistantEmail'],
        'accepted': value['accepted'],
        'executive_name': value['executiveName'],
        'is_sent_by_current_user': value['isSentByCurrentUser'],
        'invite_token': value['inviteToken'],
        'expires_at': value['expiresAt'] == null ? value['expiresAt'] : value['expiresAt'].toISOString(),
    };
}

